import React from 'react';

import { ReactComponent as Calendar } from 'assets/icons/automatic-buy-calendar.svg';

const RolloverInstructionContent = (accountName) => {
  return {
    title: 'Fund with a rollover',
    subtitle: <span>To fund your brokerage account, you must first move assets into your <span id="funding-modal-step-2-accountName">{accountName}</span> sweep account. You can roll over an old workplace retirement account, such as your 401(k), into your new brokerage IRA.</span>,
    steps: [
      {
        content: 'Provide the plan details for your old retirement account'
      },
      {
        content:
          "Determine whether you need a direct or indirect rollover and how much you'll be rolling over"
      },
      {
        content:
          'Call your institution to request a Rollover Distribution Check'
      }
    ],
    notes: [
      {
        content:
          'Rollover may take 2-4 weeks, depending on your rollover type and previous provider. We will provide a step-by-step guide to help you obtain and file the necessary documents.',
        icon: <Calendar />
      }
    ]
  };
};

export default RolloverInstructionContent;
